import MyConcepts from './MyConcepts';
import './MyConcepts.scss';

export default MyConcepts;